import { render, staticRenderFns } from "./TituloFechamentoCursoTurma.vue?vue&type=template&id=574fd118&"
import script from "./TituloFechamentoCursoTurma.vue?vue&type=script&lang=js&"
export * from "./TituloFechamentoCursoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports